export const isSidebarVisible = (state: any) => state.navigation.sidebarOpen;
